namespace TabAurous.Reports {
    export interface ItemsRegisterResponse extends Serenity.ServiceResponse {
        Parties?: Common.Party[];
        Vouchers?: Common.Vouchers[];
    }
}
